import React, { useLayoutEffect, useState } from 'react';

function getSize(el: HTMLElement | null) {
  if (!el) {
    return {
      width: 0,
      height: 0,
    };
  }
  return {
    width: el.offsetWidth,
    height: el.offsetHeight,
  };
}

export function useComponentSize(ref: React.RefObject<HTMLElement>) {
  let [ComponentSize, setComponentSize] = useState(getSize(ref.current));

  const handleResize = () => {
    if (ref.current) {
      const size = getSize(ref.current);
      setComponentSize(size);
    }
  };

  useLayoutEffect(() => {
    if (!ref.current) {
      return;
    }

    let resizeObserver = new ResizeObserver(() => handleResize());
    resizeObserver.observe(ref.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [ref.current]);

  return ComponentSize;
}
